import {Component, OnInit, ViewChild, Output, EventEmitter, Input, HostListener} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ConstantsService} from '../../../../services/constants.service';
import {UserService} from '../services/user.service';
import {UrlService} from '../../../../services/url.service';
import {ApiClientService} from '../../../../services/api-client.service';

declare const swal;
declare const toastr;

@Component({
    selector: 'edit-name-modal',
    templateUrl: './edit-name-modal.component.html',
    styleUrls: ['./edit-name-modal.component.scss']
})
export class EditNameModalComponent implements OnInit {
    @Input() modalType;
    @Input() itemData;
    @Output() onClose = new EventEmitter();
    @ViewChild('form') form;

    public disabledSubmit = false;

    constructor(public urlService: UrlService,
                public userService: UserService,
                public api: ApiClientService) {
    }

    ngOnInit() {
        this.urlService.modalOpened.emit();
    }

    close() {
        if (this.form.dirty) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => this.onClose.emit()
            );
        } else
            this.onClose.emit();
    }

    onSubmit(form: NgForm) {
        if (form.invalid) return toastr.error('Name field must be filled');
        this.disabledSubmit = true;
        this.submitUserData();
    }

    updateView(msg: string): void {
        toastr.success(msg);
    }

    submitUserData(): void {
        const newUserData: any = {
            fullName: this.itemData.fullName
        };
        this.userService.update(this.itemData.id, newUserData).subscribe(
            res => {
                this.userService.get();
                this.onClose.emit();
                toastr.success('User successfully updated.');
            },
            err => {
                this.api.errorHandler(err);
                try {
                    const body = JSON.parse(err._body);
                    const errorFields = Object.keys(body.fields);
                    errorFields.forEach(field => toastr.error(body.fields[field].errors[0].description));
                    this.disabledSubmit = false;
                } catch(err) {
                    toastr.error('User update failed.');
                    this.disabledSubmit = false;
                }
            }
        );
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.close(), 100);
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/admin/user/edit-name-modal/edit-name-modal.component.ts